import styled from 'styled-components';

export const StyledEmptyMessage = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  opacity: 0.2;
  padding: 5rem 0;
`;
